export default __webpack_public_path__ + "green-checkmark.9522b7730902116a433d72ff56e1b667.png";